module.exports = __webpack_public_path__ + "img/1.41e2c1f1.png";